module.exports = __webpack_public_path__ + "images/emoji/clock3.fe01ca4b86c3abf69b43.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/clock3.png
// module id = BBH8
// module chunks = 2